var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AfyCardKpi, AfyCardNotice } from "@affinitysystemsgroup/assurehub-ui";
import { COBRANZA_SUMMARY_SECTION_LABEL } from "../../../constants/cobranza.constants";
import { DetailSectionLabel } from "../../CollectionDetail/style/collectionDetail.style";
import { RejectedPoliciesModalView } from "../../RejectedPoliciesModal/view/rejectedPoliciesModal.view";
import { useCollectionSummary } from "../hook/collectionSummary.hook";
import { SummaryKpiGrid, SummaryNoticeGrid, } from "../style/collectionSummary.style";
export var CollectionSummaryView = function (props) {
    var p = useCollectionSummary(props);
    if (!p.hasSummary)
        return null;
    return (_jsxs("section", { children: [_jsx(DetailSectionLabel, { children: COBRANZA_SUMMARY_SECTION_LABEL }), _jsx(SummaryKpiGrid, { children: p.kpis.map(function (kpi) { return (_jsx(AfyCardKpi, { value: kpi.value, label: kpi.label, tone: kpi.tone }, kpi.id)); }) }), p.notices.length > 0 && (_jsx(SummaryNoticeGrid, { children: p.notices.map(function (notice) { return (_jsx(AfyCardNotice, { tone: notice.tone, title: notice.title, action: notice.actionLabel
                        ? {
                            label: notice.actionLabel,
                            onClick: function () { return p.onOpenNotice(notice.id); },
                        }
                        : undefined }, notice.id)); }) })), _jsx(RejectedPoliciesModalView, __assign({}, p.modal))] }));
};
